import { render, staticRenderFns } from "./listaValidacao.vue?vue&type=template&id=54b73271&scoped=true&"
import script from "./listaValidacao.vue?vue&type=script&lang=js&"
export * from "./listaValidacao.vue?vue&type=script&lang=js&"
import style0 from "./listaValidacao.vue?vue&type=style&index=0&id=54b73271&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b73271",
  null
  
)

export default component.exports